import Icon from '../components/Icon.vue'

Icon.register({
  cannabis: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M503.5 360.3C501.9 359.4 471.1 343.4 426.7 334.4 490.9 259.3 510.7 172.8 511.6 168.8 512.8 163.5 511.2 157.9 507.3 154 504.3 151 500.2 149.3 496 149.3 494.9 149.3 493.7 149.4 492.6 149.7 488.7 150.6 406 169.3 332 229.5 332 228 332 226.5 332 225.1 332 106.3 272 11.4 269.5 7.4A16-16 0 0 1 256 0C250.6 0 245.5 2.8 242.5 7.4 240 11.4 180 106.3 180 225.1 180 226.5 180 228 180 229.5 106 169.3 23.3 150.6 19.4 149.7 18.3 149.5 17.1 149.3 16 149.3 11.8 149.3 7.7 151 4.7 154A16-16 0 0 1 0.4 168.8C1.3 172.8 21.1 259.3 85.3 334.4 40.9 343.4 10.1 359.4 8.5 360.3A16-16 0 0 1 8.5 388.5C11 389.8 69.3 420.3 142 420.3 148.1 420.3 154 420.2 159.5 419.9 148.1 442.2 143 458.3 142.7 459.2 140.9 464.9 142.4 471.1 146.6 475.3A16-16 0 0 1 162.7 479.3C164.5 478.7 200.4 467.3 240 440V504C240 508.4 243.6 512 248 512H264C268.4 512 272 508.4 272 504V440C311.6 467.3 347.5 478.7 349.3 479.3A16-16 0 0 1 365.4 475.3C369.6 471.1 371.1 464.9 369.3 459.2 369 458.3 363.9 442.2 352.5 420 358 420.2 363.9 420.3 370 420.3 442.7 420.3 501 389.8 503.5 388.6 508.7 385.8 512 380.3 512 374.4 512 368.5 508.7 363 503.5 360.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/cannabis.js
// module id = mEWF
// module chunks = 144